// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"744":"618d4f66","868":"4b277a29"}[chunkId] + ".chunk.js";
};